import { useStarterDashboardV2PageFcmExperiments } from 'src/app/pages/starterDashboardV2/pageContext';

export type UseShareRecommendationsExperiment = ModelHookResult<{
	variant: string;
}>;

export function useShareRecommendationsExperiment(): UseShareRecommendationsExperiment {
	const { shareRecommendationsExperiment } = useStarterDashboardV2PageFcmExperiments();

	return {
		data: {
			variant: shareRecommendationsExperiment.variation,
		},
	};
}
